import { render } from "./ModalLogin.vue?vue&type=template&id=64f8a050"
import script from "./ModalLogin.vue?vue&type=script&lang=js"
export * from "./ModalLogin.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__